export default __webpack_public_path__ + "static/media/blue-bullet.ec265f30.svg";